import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import PartnerController, {
  PartnerListType,
  UserListType,
  SalesListType,
} from '../../../controller/PartnerController';
import toast, { Toaster } from 'react-hot-toast';

const PartnerMapping = () => {
  const navigate = useNavigate();
  const [selectedPartner, setSelectedPartner] = useState<PartnerListType | null>(null);
  const [selectedUser, setSelectedUser] = useState<UserListType | null>(null);
  const [partnerList, setPartnerList] = useState<PartnerListType[]>([]);
  const [userList, setUserList] = useState<any[]>([]);
  const [hotelList, setHotelList] = useState<SalesListType[]>([]);
  const [storeList, setStoreList] = useState<SalesListType[]>([]);
  const [selectedSales, setSelectedSales] = useState<number[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handlePartnerChange = (selectedPartner: PartnerListType | null) => {
    setSelectedPartner(selectedPartner);
    setSelectedUser(null);
  };
  const handleUserChange = (selectedUser: UserListType | null) => {
    console.log('selectedUser>>', selectedUser);
    setSelectedUser(selectedUser);
  };
  const handleSalesChange = (userId: number) => {
    setSelectedSales((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId],
    );
  };

  // 매장명 검색
  const filteredStores = storeList.filter((store) =>
    store.store_name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const getSalesList = async () => {};

  // 영업담당자 선택
  const getUsersBySales = async () => {
    try {
      const response = await PartnerController.getUsersBySales();

      if (response && response.data) {
        const salesData = response.data.data.users_by_sales;
        console.log('salesData<<<', salesData);
        const formattedPartnerist = salesData?.map((item: PartnerListType) => ({
          value: item.sales_id,
          label: item.sales_name,
          sales_id: item.sales_id,
          users: item.users,
        }));
        setPartnerList(formattedPartnerist);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 호텔,매장리스트 및 등록자 확인
  const getHotelAndStoreSalesRelation = async () => {
    try {
      const response = await PartnerController.getHotelAndStoreSalesRelation();

      if (response && response.data) {
        const hotelData = response.data.data.hotel;
        const storeData = response.data.data.store;

        setHotelList(hotelData);
        setStoreList(storeData);

        const matchingHotelIds = hotelData
          .filter((data: any) => data.sales_relation?.user_id === selectedUser?.user_id)
          .map((data: any) => data.store_id);

        const matchingStoreIds = storeData
          .filter((data: any) => data.sales_relation?.user_id === selectedUser?.user_id)
          .map((data: any) => data.store_id);

        console.log('response======>', response.data.data);

        setSelectedSales([...matchingHotelIds, ...matchingStoreIds]);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // 정보 저장
  const setSalesRelation = async () => {
    if (selectedPartner && selectedUser) {
      const oData = {
        sales_id: selectedPartner.sales_id,
        user_id: selectedUser.user_id,
        store_ids: selectedSales,
      };
      try {
        const response = await PartnerController.setSalesRelation(oData);

        if (response && response.data) {
          getHotelAndStoreSalesRelation();
          toast.success('저장되었습니다.');
        } else {
          toast.error('다시 시도해주세요.');
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };
  useEffect(() => {
    getUsersBySales();
  }, []);
  useEffect(() => {
    if (selectedPartner) {
      const formattedUsers = selectedPartner.users?.map((item: UserListType) => ({
        value: item.user_id,
        label: item.user_name,
        user_id: item.user_id,
      }));
      setUserList(formattedUsers);
    }
  }, [selectedPartner]);
  useEffect(() => {
    if (selectedUser) {
      getHotelAndStoreSalesRelation();
    }
  }, [selectedUser]);
  console.log('selectedSales>>>', selectedSales);
  return (
    <Style>
      <div className="rightContentWrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h2>KNOCKKNOCK 영업사 맵핑</h2>
        <div className="partnerSettingWrap">
          <div className="selectWrap">
            <p>영업사</p>
            <Select
              options={partnerList}
              value={selectedPartner}
              onChange={handlePartnerChange}
              placeholder="영업사를 선택해주세요."
            />
          </div>
          {selectedPartner && (
            <div className="selectWrap">
              <p>영업자</p>
              <Select
                options={userList}
                value={selectedUser}
                onChange={handleUserChange}
                placeholder="영업자를 선택해주세요."
              />
            </div>
          )}
        </div>
        {selectedUser && (
          <>
            {hotelList.length > 0 && (
              <div className="hotelListWrap">
                <h2 className="title">영업한 호텔을 선택해주세요.</h2>

                <div className="hotelList">
                  {hotelList.map((hotel) => {
                    const hotelDeisabled =
                      hotel.sales_relation !== null &&
                      hotel.sales_relation?.user_id !== selectedUser.user_id;
                    return (
                      <div
                        className={`listWrap  ${hotelDeisabled && 'disabled'}`}
                        key={hotel.store_id}>
                        <label>
                          <input
                            type="checkbox"
                            name="hotel"
                            value={hotel.store_id}
                            onChange={() => handleSalesChange(hotel.store_id)}
                            checked={selectedSales.includes(hotel.store_id)}
                            disabled={hotelDeisabled}
                          />
                          <p>{hotel.store_name}</p>
                          {hotel.sales_relation !== null && (
                            <div className="userBox">
                              <p>{hotel.sales_relation?.sales_name}-{hotel.sales_relation?.user_name}</p>
                            </div>
                          )}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {storeList.length > 0 && (
              <div className="storeListWrap">
                <h2 className="title">영업한 매장을 선택해주세요.</h2>
                <input
                  className="searchStore"
                  type="text"
                  placeholder="매장명 검색하세요."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="storeList">
                  {filteredStores.map((store) => {
                    const storeDeisabled =
                      store.sales_relation !== null &&
                      store.sales_relation?.user_id !== selectedUser.user_id;
                    return (
                      <div
                        className={`listWrap  ${storeDeisabled && 'disabled'}`}
                        key={store.store_id}>
                        <label>
                          <input
                            type="checkbox"
                            name="store"
                            value={store.store_id}
                            onChange={() => handleSalesChange(store.store_id)}
                            checked={selectedSales.includes(store.store_id)}
                            disabled={storeDeisabled}
                          />
                          <p>{store.store_name}</p>
                          {store.sales_relation !== null && (
                            <div className="userBox">
                              {storeDeisabled}
                              <p>{store.sales_relation?.sales_name}-{store.sales_relation?.user_name}</p>
                            </div>
                          )}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <button className="submitButton" onClick={setSalesRelation}>
              설정하기
            </button>
          </>
        )}
      </div>
    </Style>
  );
};

export default PartnerMapping;

const Style = styled.div`
  /* 공통 */
  p {
    padding: 0;
    margin: 0;
    font-size: 16px;
  }
  input {
    accent-color: #40977f;
  }
  .css-b62m3t-container {
    width: 100%;
    margin-bottom: 10px;
  }

  /* rightContentWrap */
  .rightContentWrap {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 2% 4%;
  }

  /* selectWrap */
  .selectWrap {
    width: 30%;

    p {
      margin-bottom: 6px;
    }
  }
  /* partnerSettingWrap */
  .partnerSettingWrap {
    display: flex;
    align-items: center;
    gap: 3%;
    margin: 20px 0;
  }
  .title {
    margin-bottom: 4px;
    font-size: 18px;
    font-weight: 600;
  }

  /* searchStore */
  .searchStore {
    width: 100%;
    padding: 10px 4px;
    border: none;
    border-bottom: 1px solid #ddd;
    outline: none;
  }
  /* hotelListWrap/storeListWrap */
  .hotelListWrap,
  .storeListWrap {
    margin-bottom: 50px;
  }
  .hotelList,
  .storeList {
    margin-top: 14px;
    border: 1px solid #eee;
    max-height: 500px;
    overflow-y: auto;
  }
  .storeList {
    margin-top: 14px;
  }
  .storeList > .listWrap,
  .hotelList > .listWrap {
    border-bottom: 1px solid #eee;

    label {
      padding: 10px 12px;
    }
  }
  .storeList > .listWrap:last-child,
  .hotelList > .listWrap:last-child {
    border-bottom: none;
  }
  .listWrap.disabled {
    background: #eee;

    label {
      justify-content: flex-start;
      cursor: not-allowed;
      input {
        cursor: not-allowed;
      }
      p {
        color: #bbb;
      }
    }
    .userBox {
      background: #ddd;
    }
  }
  label {
    display: flex;
    align-items: center;
    font-size: 16px;

    input {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .userBox {
    margin-left: 6px;
    padding: 4px 4px 2px 4px;
    background: rgb(77, 210, 174);
    border-radius: 4px;

    p {
      font-size: 12px;
      color: #fff;
    }
  }

  .submitButton {
    width: 100%;
    padding: 10px;
    border: none;
    outline: none;
    font-size: 18px;
    border-radius: 4px;
    background: rgb(77, 210, 174);
    color: #fff;
  }
  @media (max-width: 800px) {
    .selectWrap {
      width: 50%;
    }
  }
  @media (max-width: 500px) {
    .partnerSettingWrap {
      flex-direction: column;
    }
    .selectWrap {
      width: 100%;
    }
  }
`;
